import { useFormikContext } from "formik";
import { useEffect, useState } from "react";

export const ScrollToFieldError = () => {
  const { isValid, errors } = useFormikContext();
  const [lastFocusedElement, setLastFocusedElement] = useState<
    Element | undefined
  >();
  useEffect(() => {
    if (isValid || !errors) return;

    const foundElements = document.querySelectorAll(
      ".dots-input-error, .dots-error-message, .avis-input-error",
    );
    if (foundElements.length === 0) return;

    if (foundElements[0] != lastFocusedElement) {
      setLastFocusedElement(foundElements[0]);
      // Scroll to first known error into view
      foundElements[0].scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [errors, isValid, lastFocusedElement]);

  return null;
};
